import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import { StorageItem } from './storage-item.model';
import { StorageItemInterface } from './storage-item.interface';
import { StorageItemFactory } from './storage-item.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import 'rxjs/add/observable/throw';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class StorageItemService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<StorageItem>> {
        // this.authService.checkToken(() => {
            return this.http
                // tslint:disable-next-line:max-line-length
                .get<StorageItemInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/storage-items`, { params, headers: this.authService.headers() })
                .pipe(map(data => data
                    .map(item => StorageItemFactory.fromObject(item)),
                ), catchError(this.errorHandler));
        // });
    }

    getSingle(id: string): Observable<StorageItem> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<StorageItemInterface>(`${environment.apiUrl}/v${environment.apiVersion}/storage-items/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => StorageItemFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(storageItem: StorageItem): Observable<any> {

        // storage-item.tabs = _.keyBy(storage-item.tabs, 'id');

        if (storageItem.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/storage-items/${storageItem.id}`, storageItem, { headers: this.authService.headers() })
                .pipe(map(item => StorageItemFactory.fromObject(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/storage-items`, storageItem, { headers: this.authService.headers() })
            .pipe(map(item => StorageItemFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    /*remove(isbn: string): Observable<any> {
        return this.http
            .delete(`${this.api}/storage-item/${isbn}`, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }
 */

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<StorageItem>> {
        return this.http
            .get<StorageItemInterface[]>(`${this.api}/storage-items/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawStorageItem => StorageItemFactory.fromObject(rawStorageItem)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/shared/storage-items/shared/storage-item.service.ts